import type { Context } from "@lit/context";
import { createContext } from "@lit/context";
import type { Commander } from "#app/commander.ts";
import type { ShortcutsController } from "#app/shortcuts-controller.ts";
import type { TvrnService } from "#app/tvrn-service.ts";

export const tvrnServiceCtx: Context<unknown, TvrnService> = createContext(
  Symbol("tvrn-service"),
);

export const commanderCtx: Context<
  unknown,
  Commander<TvrnCommandsMap>
> = createContext(Symbol("commander"));

export const shortcutsCtx: Context<unknown, ShortcutsController> =
  createContext(Symbol("shortcuts"));
